module.exports = __webpack_public_path__ + "img/tointos06.197ff13a.jpg";